import React, { useMemo } from "react";
// import { useNavigate } from "react-router-dom";

import {
  Grid,
  Autocomplete,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  Box,
  Button
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import IconButton from "@mui/material/IconButton";
import { useEffect, useState } from "react";
import { billList, billSettlement } from "../../../Services/Services";
import Popover from '@mui/material/Popover';
const BillSummaryTable = () => {
  const [billData, setBillData] = useState([])
  const [anchorEl, setAnchorEl] = useState(null);
  const [settelement, setSetelement] = useState(null);
  const [filters, setFilters] = useState({
    branch: null,
    billId: null,
    freightId: null,
    party: null,
  });
  useEffect(() => {
    const fetchBillList = async () => {
      const data = await billList();
      if (data) {
        setBillData(data);
      }
    };
    fetchBillList();
  }, []);
  const handleComplete = async (id) => {
    const data = await billSettlement(id);
    setBillData(data);
  };
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const filteredData = useMemo(() => {
    return billData.filter((row) => {
      const matchBranch = filters.branch
        ? row.branch_name === filters.branch
        : true;
      const matchBillId = filters.billId
        ? row.bill_id === filters.billId
        : true;
      const matchFreightId = filters.freightId
        ? row.freight_id === filters.freightId
        : true;
      const matchParty = filters.party
        ? row.party_name === filters.party
        : true;

      return matchBranch && matchBillId && matchFreightId && matchParty;
    });
  }, [filters]);

  const branchOptions = [...new Set(billData.map((d) => d.branch_name))];
  const billIdOptions = [...new Set(billData.map((d) => d.bill_id))];
  const freightIdOptions = [...new Set(billData.map((d) => d.freight_id))];
  const partyOptions = [...new Set(billData.map((d) => d.party_name))];

  const handlePrintClick = (row) => {
    const printWindow = window.open("", "", "height=600,width=1000");
    printWindow.document.write(`
     <html>
<head>
  <title>LR Bill</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      padding: 20px;
      background-color: #fff;
    }
    .center {
      text-align: center;
    }
    .title {
      font-size: 32px;
      font-weight: bold;
    }
    .subtitle {
      font-size: 13px;
    }
    .info-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      font-size: 12px;
    }
    .info-table td {
      border: 1px solid black;
      padding: 4px;
      vertical-align: top;
    }
    th{
         background-color: rgba(211, 211, 211, 0.42); /* light grey */
            color: #000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
    .small-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      font-size: 12px;
    }
    .small-table th, .small-table td {
      border: 1px solid black;
      padding: 4px;
      text-align: center;
    }
    .small-table thead {
      background-color: #f0f0f0;
      font-weight: bold;
    }
    #footer-print {
      position: fixed;
            bottom: 25px;
            width: 100%;
            text-align: center;
    }
    #hrtag {
      position: fixed;
            bottom: 0px;
            width: 100%;
    }
    .contact {
      display: flex;
      justify-content: center;
      gap: 20px;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 8px;
      font-size: 14px;
    }
    .contact-item {
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .icon {
      font-size: 16px;
      color: #d4af37;
    }
    .whatsapp-icon {
      color: #25D366;
    }
      footer {
            position: fixed;
            bottom: 0px;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #333;
          }
  </style>
</head>
<body>

  <div class="center">
    <div class="title">S. R. ENTERPRISES</div>
    <div class="subtitle">Transport Contractor & Commission Agent</div>
  </div>

  <br/>

  <table class="info-table">
    <tr>
      <td>Ashutosh Ku. Singh</td>
      <td>Bill ID: SRE/491/PT</td>
      <td>TO,</td>
    </tr>
    <tr>
      <td>PAN Number: LZQPS9703J</td>
      <td>Bill Date: 25-03-2025</td>
      <td>PRINCE TRANSPORT</td>
    </tr>
    <tr>
      <td>Account Name: S.R. ENTERPRISES</td>
      <td>Total Amount: ₹49,700</td>
      <td>WARD NO 7 NAGPUR CHOURAHA,</td>
    </tr>
    <tr>
      <td>A/C No: 50200079484752</td>
      <td rowspan="3"></td>
      <td>DISR.-MCB (C.G.) 497442</td>
    </tr>
    <tr>
      <td>IFSC Code: HDFC0006110</td>
      <td rowspan="2"></td>
    </tr>
    <tr>
      <td>Bank: HDFC BANK (RAIPUR)</td>
    </tr>
  </table>

  <table class="small-table">
    <thead>
      <tr>
        <th>S. No</th>
        <th>Date</th>
        <th>Truck No.</th>
        <th>Weight</th>
        <th>Rec. Weight</th>
        <th>Short</th>
        <th>Rate</th>
        <th>Adv.</th>
        <th>Remark</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td>${row.bill_date}</td>
        <td>TRK1234</td>
        <td>28.79</td>
        <td>28.94</td>
        <td>0</td>
        <td>1000</td>
        <td>25700</td>
        <td></td>
      </tr>
    </tbody>
  </table>

  <div id="footer-print">
    <div>Near RTO Office, Transport Nagar, Raipur (C.G.) 493221</div>
    <div class="contact">
      <div class="contact-item">📞 8602856129</div>
      <div class="contact-item">📱 8602856129</div>
      <div class="contact-item">✉ singhashu1555@gmail.com</div>
    </div>
  </div>
  <hr style="border: none; border-top: 1px solid #aaa; margin: 20px 0;" id="hrtag" />
<footer>Powered by : YASHVITECH IT SOLUTION PVT LTD</footer>
  <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() {
        window.close();
      };
    };
  </script>

</body>
</html>

    `);

    printWindow.document.close();
  };
  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    if (format === "dd-mm-yyyy") {
      return `${day}-${month}-${year}`;
    } else if (format === "yyyy-mm-dd") {
      return `${year}-${month}-${day}`;
    } else {
      throw new Error("Unsupported format. Use 'dd-mm-yyyy' or 'yyyy-mm-dd'.");
    }
  }
  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            options={branchOptions}
            value={filters.branch}
            onChange={(e, newValue) => handleFilterChange("branch", newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search by Branch Name"
                size="small"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            options={billIdOptions}
            value={filters.billId}
            onChange={(e, newValue) => handleFilterChange("billId", newValue)}
            renderInput={(params) => (
              <TextField {...params} label="Search by Bill ID" size="small" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            options={freightIdOptions}
            value={filters.freightId}
            onChange={(e, newValue) =>
              handleFilterChange("freightId", newValue)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search by LR ID"
                size="small"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            options={partyOptions}
            value={filters.party}
            onChange={(e, newValue) => handleFilterChange("party", newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search by Party Name"
                size="small"
              />
            )}
          />
        </Grid>
      </Grid>

      <TableContainer sx={{ overflowX: "auto", mt: 2, maxWidth: "100%" }}>
        <Table
          size="small"
          sx={{
            tableLayout: "auto",
            "& td, & th": {
              textAlign: "center",
              whiteSpace: "nowrap",
              padding: "0px 8px",
              fontSize: "0.8125rem",
              borderBottom: "1px solid #ccc",
            },
          }}
        >
          <TableHead
            sx={{
              "& th": {
                fontWeight: "bold",
                color: (theme) =>
                  theme.palette.mode === "dark" ? "#2196f3" : "#333",
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "black" : "#f5f5f5",
              },
            }}
          >
            <TableRow>
              <TableCell>Settlement</TableCell>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Bill ID</TableCell>
              <TableCell>Party Name</TableCell>
              <TableCell>Branch Name</TableCell>
              <TableCell>Bill Date</TableCell>
              <TableCell>Total Amount</TableCell>
              <TableCell>Received Amount</TableCell>
              <TableCell>Balance Amount</TableCell>
              <TableCell
                align="center"
                className="no-print"
                sx={{
                  position: "sticky",
                  right: 0,
                  backgroundColor: "#fff",
                  zIndex: 1,
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {billData.length > 0 ? (
              billData.map((row, index) => {
                return (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox size="small"

                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setSetelement(row.billing_id);
                        }}

                      />
                    </TableCell>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.billing_id}</TableCell>
                    <TableCell>{row.party_name}</TableCell>
                    <TableCell>{row.branch_name}</TableCell>
                    <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    <TableCell>{row.total_amount}</TableCell>
                    <TableCell>{row.paid_amount}</TableCell>
                    <TableCell>{row.rem_amount}</TableCell>
                    <TableCell
                      align="center"
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                      }}
                    >
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => handlePrintClick(row)}
                      >
                        <PrintIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
            
        </Table>
      </TableContainer>
       <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={() => {
                setAnchorEl(null);
                setSetelement(null);
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Box sx={{ p: 1 }}>
                <Typography variant="body2">Are you sure?</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                  <Button
                    color="error"
                    size="small"
                    onClick={async () => {
                      try {
                        await handleComplete(settelement);
                      } finally {
                        setAnchorEl(null);
                        setSetelement(null);
                      }
                    }}
                  >
                    Yes
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      setAnchorEl(null);
                      setSetelement(null);
                    }}
                  >
                    No
                  </Button>
                </Box>
              </Box>
            </Popover>
    </>
  );
};

export default BillSummaryTable;